const swiperElements = document.querySelectorAll('.nxt-swiper')

swiperElements.forEach(swiperElement => {
  // Extract data attributes
  const autoplay = swiperElement.getAttribute('data-autoplay') === 'true'
  const autoplaySpeed = parseInt(swiperElement.getAttribute('data-autoplay-speed'), 10)
  const slidesPerView = parseInt(
    swiperElement.getAttribute('data-slides-per-view'),
    10
  )

  const breakpointsAttr = swiperElement.getAttribute('data-breakpoints')
  let breakpoints = null
  if (breakpointsAttr && breakpointsAttr.trim() !== '') {
    try {
      breakpoints = JSON.parse(breakpointsAttr)
    } catch (e) {
      console.warn('Failed to parse breakpoints:', e)
      breakpoints = null
    }
  }

  const navigation = swiperElement.getAttribute('data-navigation') === 'true'
  const keyboard = swiperElement.getAttribute('data-keyboard') === 'true'
  const direction = swiperElement.getAttribute('data-direction')
  const effect = swiperElement.getAttribute('data-effect')
  const centeredSlides = swiperElement.getAttribute('data-centered-slides') === 'true'
  const pagination = swiperElement.getAttribute('data-pagination') === 'true'
  const paginationDynamic = swiperElement.getAttribute('data-pagination-dynamic') === 'true'
  const scrollbar = swiperElement.getAttribute('data-scrollbar') === 'true'
  const autoHeight = swiperElement.getAttribute('data-autoheight') === 'true'
  const mousewheel = swiperElement.getAttribute('data-mousewheel') === 'true'
  const animationSpeed = swiperElement.getAttribute('data-speed')
  
  // Try to get spacing from either data-space-between or data-spacing
  let spaceBetween;
  if (swiperElement.hasAttribute('data-space-between')) {
    spaceBetween = parseInt(swiperElement.getAttribute('data-space-between'), 10);
  } else if (swiperElement.hasAttribute('data-spacing')) {
    spaceBetween = parseInt(swiperElement.getAttribute('data-spacing'), 10);
  } else {
    // Default value
    spaceBetween = 20;
  }
  // console.log('Spacing value used:', spaceBetween);
  
  // Check for spacing in the HTML output
  const allAttributes = swiperElement.getAttributeNames();
  // console.log('All data attributes:', allAttributes.filter(attr => attr.startsWith('data-')));
  
  const height = convertToPixels(swiperElement.getAttribute('data-height'))
  const loop = swiperElement.getAttribute('data-loop') === 'true'
  
  // For cards and flip effects, use 'auto' for slidesPerView
  let finalSlidesPerView = slidesPerView
  if (effect === 'cards' || effect === 'flip') {
    finalSlidesPerView = 'auto'
  }
  
  const config = {
    autoHeight: autoHeight,
    loop: loop,
    a11y: true,
    speed: animationSpeed ? animationSpeed : 2500,
    spaceBetween: isNaN(spaceBetween) ? 20 : spaceBetween,
    slidesPerView: finalSlidesPerView,
    centeredSlides: centeredSlides,
    keyboard: keyboard,
    direction: direction
  }

  if (height) {
    config.height = height
  }

  if (effect) {
    config.effect = effect
    config.grabCursor = true  // Required for cards and flip effects
    // Cards effect specific configuration
    if (effect === 'cards') {
      config.cardsEffect = {
        slideShadows: true,
        perSlideOffset: 8,
        perSlideRotate: 2
      }
    }
    // Flip effect specific configuration
    if (effect === 'flip') {
      config.flipEffect = {
        slideShadows: true,
        limitRotation: true
      }
    }
  }

  if (autoplay) {
    config.autoplay = {
      delay: autoplaySpeed ? autoplaySpeed : 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    }
  }

  if (navigation) {
    const nextButton = swiperElement.querySelector('.swiper-button-next')
    const prevButton = swiperElement.querySelector('.swiper-button-prev')
    if (nextButton && prevButton) {
      config.navigation = {
        enabled: true,
        nextEl: nextButton,
        prevEl: prevButton
      }
    }
  }

  if (scrollbar) {
    const scrollbarEl = swiperElement.querySelector('.swiper-scrollbar')
    if (scrollbarEl) {
      config.scrollbar = {
        enabled: true,
        el: scrollbarEl,
        draggable: true
      }
    }
  }

  if (pagination) {
    const paginationEl = swiperElement.querySelector('.swiper-pagination')
    if (paginationEl) {
      config.pagination = {
        enabled: true,
        el: paginationEl,
        type: 'bullets',
        clickable: true
      }
      
      // Add dynamic bullets if enabled
      if (paginationDynamic) {
        config.pagination.dynamicBullets = true
        config.pagination.dynamicMainBullets = 5
      }
    }
  }

  if (mousewheel) {
    config.mousewheel = {
      enabled: true,
      sensitivity: 0.5,
      threshold: 50,
      thresholdTime: 200
    }
  }

  if (breakpoints && breakpoints.length > 0) {
    config.breakpoints = {}
    breakpoints.forEach(breakpoint => {
      const bpConfig = {}
      // For cards/flip effects, keep slidesPerView as 'auto' in breakpoints too
      if (effect === 'cards' || effect === 'flip') {
        bpConfig.slidesPerView = 'auto'
      } else {
        bpConfig.slidesPerView = parseInt(breakpoint.slides_per_view, 10)
      }
      config.breakpoints[`${breakpoint.breakpoint}`] = bpConfig
    })
  }

  // Try to create Swiper with effect
  let swiper
  try {
    swiper = new Swiper(swiperElement, config)
    
    // Verify effect was applied
    if (effect && !swiperElement.classList.contains(`swiper-${effect}`)) {
      console.warn(`Swiper effect '${effect}' was not applied. Swiper bundle may not include ${effect} effect module.`)
      console.warn('Reinitializing without effect...')
      
      // Destroy and recreate without effect
      swiper.destroy(true, true)
      delete config.effect
      delete config.cardsEffect
      delete config.flipEffect
      config.slidesPerView = slidesPerView // Reset to original
      swiper = new Swiper(swiperElement, config)
    }
  } catch (error) {
    console.error('Error initializing Swiper:', error)
    // Try without effect as fallback
    if (effect) {
      console.warn('Retrying without effect...')
      delete config.effect
      delete config.cardsEffect
      delete config.flipEffect
      config.slidesPerView = slidesPerView
      swiper = new Swiper(swiperElement, config)
    }
  }
})

function convertToPixels (value) {
  const element = document.createElement('div')
  element.style.position = 'absolute'
  element.style.visibility = 'hidden'
  element.style.height = value
  document.body.appendChild(element)
  const pixels = element.offsetHeight
  document.body.removeChild(element)
  return pixels
}
